/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {useStore} from '../../../../store/store';
import {observer} from 'mobx-react';
import PageWrapper from '../../../modules/PageWrapper';
import Filters from '../../../table/sales/filters/Filters';
import Presets from '../../../table/sales/Presets';
import {getFilters} from './getFilters';
import {filtersAll, filtersTeamlead, filtersManager} from './filtersConfigs';
import {groupsAll, groupsTeamleader, groupsManager} from './groupsConfigs';
import TableWrapper from '../../../table/sales/TableWrapper';
import Columns from '../../../table/sales/Columns';
import {baseFields} from '../../../table/sales/customizationTable';
import BlankSheet from '../../../table/sales/BlankSheet';
import FullScreen from '../../../table/sales/FullScreen';
import Refresh from '../../../table/sales/Refresh';
import ResultsCount from '../../../table/sales/ResultsCount';
import Navigation from '../../../modules/NavigationBloggers';

const filtersHeadOfSalesLikeLtc = [
  {
    label: '\u041e\u0431\u0449\u0438\u0435',
    options: [
      {value: 'state', label: '\u0421\u043e\u0441\u0442\u043e\u044f\u043d\u0438\u0435'},
      {value: 'type', label: '\u0418\u0441\u0442\u043e\u0447\u043d\u0438\u043a'},
      {value: 'cogort', label: '\u041a\u043e\u0433\u043e\u0440\u0442\u0430'},
    ],
  },
  {
    label: '\u041e\u0442\u0434\u0435\u043b \u043f\u0440\u043e\u0434\u0430\u0436',
    options: [{value: 'manager_id', label: '\u041c\u0435\u043d\u0435\u0434\u0436\u0435\u0440'}],
  },
  {
    label: '\u041f\u0430\u0440\u0442\u043d\u0435\u0440\u044b',
    options: [
      {value: 'brand_id', label: '\u0411\u0440\u0435\u043d\u0434'},
      {value: 'country_id', label: '\u0413\u0415\u041e'},
    ],
  },
];

const groupsHeadOfSalesLikeLtc = [
  {
    label: '\u041e\u0431\u0449\u0438\u0435',
    options: [{value: 'traffic_source', label: '\u0418\u0441\u0442\u043e\u0447\u043d\u0438\u043a'}],
  },
  {
    label: '\u041e\u0442\u0434\u0435\u043b \u043f\u0440\u043e\u0434\u0430\u0436',
    options: [{value: 'manager', label: '\u041c\u0435\u043d\u0435\u0434\u0436\u0435\u0440'}],
  },
  {
    label: '\u041f\u0430\u0440\u0442\u043d\u0435\u0440\u044b',
    options: [
      {value: 'brand', label: '\u0411\u0440\u0435\u043d\u0434'},
      {value: 'country', label: '\u0413\u0435\u043e'},
    ],
  },
];

const Statistics = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  const getListFilters = () => {
    if (store.roles.includes(8) || store.roles.includes(30)) {
      return filtersHeadOfSalesLikeLtc;
    }
    if (store.roles.includes(16) || store.roles.includes(17)) {
      return filtersTeamlead;
    }
    if (store.roles.includes(9) || store.roles.includes(15)) {
      return filtersManager;
    }

    if (
      store.roles.includes(39) ||
      store.roles.includes(32) ||
      store.roles.includes(13) ||
      store.roles.includes(38) ||
      store.roles.includes(4)
    ) {
      return filtersAll;
    }

    return [];
  };

  const getListGroups = () => {
    if (store.roles.includes(8) || store.roles.includes(30)) {
      return groupsHeadOfSalesLikeLtc;
    }
    if (store.roles.includes(16) || store.roles.includes(17)) {
      return groupsTeamleader;
    }
    if (store.roles.includes(9) || store.roles.includes(15)) {
      return groupsManager;
    }

    if (
      store.roles.includes(39) ||
      store.roles.includes(32) ||
      store.roles.includes(13) ||
      store.roles.includes(38) ||
      store.roles.includes(4)
    ) {
      return groupsAll;
    }

    return [];
  };

  return (
    <PageWrapper
      firstTimeConfig='current_week'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Отдел продаж'},
        {isSeparator: true},
        {
          title: 'Статистика RD',
          path: '/sales/rd/statistics',
          isActive: true,
        },
      ]}
      title='Статистика RD'
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'sales/rd/statistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[{filter: 'state', isFixed: false, options: ['with_data']}]}
        defaultGroups={
          store.roles.includes(15)
            ? []
            : [
                {group: 'manager', isFixed: false},
                // {group: 'pixel', isFixed: false},
              ]
        }
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields}
        disabledByDefault={[
          'qualified_cr_deposit_3',
          'qualified_cr_deposit_4',
          'qualified_cr_deposit_5',
          'deposit_1_median_amount',
          'deposit_1_cr_deposit_3',
          'deposit_1_cr_deposit_4',
          'deposit_1_cr_deposit_5',
          'deposit_2_median_amount',
          'deposit_2_median_time',
          'deposit_2_cr_deposit_4',
          'deposit_2_cr_deposit_5',
          'deposit_3_median_amount',
          'deposit_3_cr_deposit_5',
          'deposit_3_median_time',
          'deposit_4_median_amount',
          'deposit_4_median_time',
          'deposit_5_median_amount',
          'deposit_5_median_time',
        ]}
      >
        <Filters
          facebookStatisticsFilters={getListFilters()}
          facebookStatisticsGroups={getListGroups()}
          childrenRefresh={false}
          childrenHead={null}
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns columns={baseFields} />
              <Presets />
              <FullScreen />
            </>
          }
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Statistics);
